export enum NettoRateType {
  MonthRate = 0,
  DayRate = 1,
  DayRateSepareted = 2,
  KilometerRate = 3,
}
